import { mapGetters } from 'vuex';
import elementiot from 'elementiot';

export default {
  data() {
    return {
      table: null,
      gateways: null,
      timeout: null,
      deviceData: null
    };
  },
  props: {
    interval: {
      default: '1 days'
    }
  },
  async created() {
    if (this.device) {
      if (this.$route.params.token) {
        this.$store.commit('setToken', this.$route.params.token);
        if (this.$route.params.token2) {
          this.$store.commit('setGatewaysToken', this.$route.params.token2);
        } else {
          this.$store.commit('setGatewaysToken', this.$route.params.token);
        }
        
        this.$router.replace({name: 'map', params: { id: this.device }});
      }

      this.gateways = await this.fetchGateways();
      this.deviceData = await this.fetchDeviceData();

      this.init();
      this.timeout = window.setInterval(this.init, 2000);
    }
  },
  computed: {
    ...mapGetters(['auth', 'authGateways'])
  },
  methods: {
    async init() {
      try {
        let page = await this.fetchPage();
      
        this.table = page;
      } catch(e) {
        console.log(e);
      }
    },
    async fetchDeviceData() {
      try {
        let res = await elementiot.request(`https://mainova.element-iot.com/api/v1/devices/${this.device}?auth=${this.auth}`);

        if (res && res.body) {
          return res.body;
        }
      } catch (_) {
        //
      }

      return null;
    },
    async fetchGateways() {
      let gateways = {};

      try {
        let res = await elementiot.getAll(`https://mainova.element-iot.com/api/v1/tags/gateways/devices?auth=${this.authGateways}`);

        if (res) {
          res.forEach(e => {
            let interfaces = e.interfaces.filter(e => e.enabled);

            if (interfaces && interfaces.length > 0 && interfaces[0].opts && interfaces[0].opts.gateway_id) {
              gateways[interfaces[0].opts.gateway_id] = e;
            }
          });
        }
      } catch (_) {
        //
      }

      return gateways
    },
    async fetchPage(after = null, afterReading = null, sort = 'descending', beforedate = null, afterdate = null) {
      try {
        let res = await elementiot.request(`https://mainova.element-iot.com/api/v1/devices/${this.device}/packets?auth=${this.auth}&filter=packet_type+%3D%3D+%22up%22&sort_direction=${sort}&limit=100${after ? `&retrieve_after=${after}` : ''}${afterdate ? `&after=${afterdate}` : ''}${beforedate ? `&before=${beforedate}` : ''}`);
        let readings = await elementiot.request(`https://mainova.element-iot.com/api/v1/devices/${this.device}/readings?auth=${this.auth}&sort_direction=${sort}&limit=100${afterReading ? `&retrieve_after=${afterReading}` : ''}${afterdate ? `&after=${afterdate}` : ''}${beforedate ? `&before=${beforedate}` : ''}`);

        if (res && res.body) {
          if (readings && readings.body) {
            return res.body.map((e) => {
              let reading = readings.body.filter((r) => r.packet_id === e.id);

              if (reading.length > 0) {
                reading = reading[0];
              } else {
                reading = null;
              }

              return {
                ...e,
                reading
              };
            });
          } else {
            return res.body.map((e) => {
              return {
                ...e,
                reading: null
              };
            });
          }
        }
      } catch (e) {
        console.log(e);
      }

      return [];
    }
  }
}
